import React, { useEffect } from 'react';

const DoubleTheDonation = () => {
  useEffect(() => {
    // Set the DDCONF variable
    window.DDCONF = { API_KEY: "oKn6QlIVu3L1hVHX" };

    // Create a script element
    const script = document.createElement('script');
    script.src = "https://doublethedonation.com/api/js/ddplugin.js";
    script.async = true;

    // Append the script to the document head
    document.head.appendChild(script);

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div id="dd-container">
      <a href="https://doublethedonation.com/matching-grant-resources/matching-gift-basics/">Matching Gift</a> and 
      <a href="https://doublethedonation.com/matching-grant-resources/volunteer-grant-basics/">Volunteer Grant</a> information provided by 
      <br />
      <a href="https://doublethedonation.com">
        <img alt="Powered by Double the Donation" src="https://doublethedonation.com/api/img/powered-by.png" />
      </a>
    </div>
  );
};

export default DoubleTheDonation;
